module.exports = __webpack_public_path__ + "media/images/prizes__daily-a7ef7ce5b3c3c84aa527c28b1576101b.png";